// extracted by mini-css-extract-plugin
module.exports = {"footer_notification":"notification_footer_notification__31SC3","blink":"notification_blink__2tX7S"};